/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Register a trusted device for a passkey-authenticated user. Forwards to authx-auth-api with server-side-enriched ip, userAgent, and geolocation.
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * JWT issued by login-beef during passkey login. The user email is extracted from it.
     */
    token: string
    /**
     * JWK format public key generated by the browser for this device.
     */
    publicKey: {
      [k: string]: any
    }
    /**
     * Origin URL of the request (e.g. login page URL). Optional.
     */
    origin?: string
    /**
     * UUID of the parent device that triggered auto-enrolment. Optional.
     */
    parentDeviceId?: string
  }
}

export interface Response {
  /**
   * UUID of the registered trusted device.
   */
  deviceId: string
  /**
   * Email of the user the device is registered to.
   */
  email: string
  /**
   * When the trusted device was registered. ISO 8601 date-time.
   */
  createdAt: string
}

